
define('text!templates/modules/calendar/animated-session/animation/rename/form/animation-rename-form.html',[],function () { return '<div class="info-section">\n    <div class="form-section">\n        <div class="name-input"></div>\n        <div class="description-input"></div>\n        <div class="alert-list"></div>\n    </div>\n</div>\n';});

